import {
	COMMANDS,
	COMPONENT_ATTR_ID, COMPONENT_ATTR_NAME, COMPONENT_ATTR_NEW_VALUE, COMPONENT_ATTR_CAN_REVIEW,
	COMPONENT_ATTR_UPDATING,
	COMPONENT_NAME,
	OUT_COMMANDS, COMPONENT_ATTR_EDITING_ENABLED
} from '../constants';
import { debounce } from '../utils';
import { toWidget, toWidgetEditable } from 'ckeditor5/src/widget';
import { isNil, isNull, isUndefined } from 'lodash';

export const downcastEditableField = ( editor, { asWidget } ) => {
	return ( modelElement, { writer, consumable, mapper } ) => {
		const isEnabledAttr = modelElement.getAttribute( COMPONENT_ATTR_EDITING_ENABLED );
		const id = modelElement.getAttribute( COMPONENT_ATTR_ID );
		const name = modelElement.getAttribute( COMPONENT_ATTR_NAME );
		const newValue = modelElement.getAttribute( COMPONENT_ATTR_NEW_VALUE );
		const canReview = !!modelElement.getAttribute( COMPONENT_ATTR_CAN_REVIEW );
		const updatingAttr = modelElement.getAttribute( COMPONENT_ATTR_UPDATING );
		const updating = typeof updatingAttr === 'string' ? updatingAttr === 'true' : Boolean( updatingAttr );
		const isEnabled = typeof isEnabledAttr === 'string' ? isEnabledAttr === 'true' : Boolean( isEnabledAttr );
		const hasNewValue = !isNil( newValue );

		const defaultAttributes = {};
		if ( asWidget ) {
			defaultAttributes[ 'data-updating' ] = updating;
			if ( !isNil( newValue ) ) {
				defaultAttributes[ 'data-new-value' ] = newValue;
				defaultAttributes[ 'data-can-review' ] = canReview;
			}
		}
		const container = writer.createContainerElement( 'span', {
			...defaultAttributes,
			class: 'editable-field',
			'data-id': id,
			'data-name': name
		} );

		const child = modelElement.getChild( 0 );

		const onChangeIsFocused = ( eventInfo, data, isFocused, oldValue ) => {
			if ( !isFocused && oldValue ) {
				const textElement = eventInfo.source.getChild( 0 );
				const value = textElement ? textElement.data : '';
				editor.execute( COMMANDS.SET_CONTENT, { value, id, name } );
			}
		};

		const value = child.childCount === 1 ? child.getChild( 0 ).data : '';

		let buttonsReview = null;
		const text = hasNewValue ?
			writer.createContainerElement( 'span', { class: 'editable-field-title' } ) :
			writer.createEditableElement( 'span', { class: 'editable-field-title' } );
		if ( asWidget ) {
			if ( hasNewValue && canReview && !isNil( document ) ) {
				const acceptClick = () => {
					editor.execute( COMMANDS.DIFF, { id, name } );
					editor.execute( COMMANDS.SET_CONTENT, { value: newValue, id, name } );
					editor.fire( OUT_COMMANDS.DIFF_REVIEW, { type: 'accept', id, name, value: newValue } );
				};
				const rejectClick = () => {
					editor.execute( COMMANDS.DIFF, { id, name } );
					editor.fire( OUT_COMMANDS.DIFF_REVIEW, { type: 'reject', id, name, value } );
				};

				buttonsReview = writer.createUIElement( 'span', { class: 'editable-field-buttons' }, function( domDocument ) {
					const domElement = this.toDomElement( domDocument );
					const acceptBtn = document.createElement( 'button' );
					acceptBtn.classList.add( 'btn', 'btn-accept' );
					acceptBtn.innerText = editor.t( 'Accept' );
					acceptBtn.onclick = acceptClick;
					domElement.appendChild( acceptBtn );

					const rejectBtn = document.createElement( 'button' );
					rejectBtn.classList.add( 'btn', 'btn-reject' );
					rejectBtn.innerText = editor.t( 'Reject' );
					rejectBtn.onclick = rejectClick;
					domElement.appendChild( rejectBtn );

					return domElement;
				} );
			}

			text.on( 'change:text', ( eventInfo, data ) => {
				editor.fire( OUT_COMMANDS.CHANGE, { text: data.data, id, name } );
			} );

			const debouncedChangeIsFocused = debounce( onChangeIsFocused, 100 );
			text.on( 'change:isFocused', debouncedChangeIsFocused );

			toWidgetEditable( text, writer );
		}

		consumable.add( child, 'insert' );

		if ( consumable.test( child, 'insert' ) ) {
			consumable.consume( child, 'insert' );
		}

		if ( !isUndefined( isEnabledAttr ) && !isEnabled ) {
			writer.addClass( 'editable-field-disabled', text );
		}
		mapper.bindElements( child, text );
		mapper.bindElements( modelElement, container );

		if ( editor.plugins.has( 'RestrictedEditingModeEditing' ) ) {
			const restrictedContainer = writer.createContainerElement( 'span', { class: 'restricted-editing-exception' } );
			writer.insert( writer.createPositionAt( container, 'end' ), restrictedContainer );
			writer.insert( writer.createPositionAt( restrictedContainer, 'end' ), text );
		} else {
			writer.insert( writer.createPositionAt( container, 'end' ), text );
		}
		if ( !isNull( buttonsReview ) ) {
			writer.insert( writer.createPositionAt( container, 'end' ), buttonsReview );
		}

		if ( asWidget ) {
			toWidget( container, writer, { widgetLabel: COMPONENT_NAME } );
		}
		return container;
	};
};
